import { ArrowBack } from "@mui/icons-material";
import { IconButton, Tab, Tabs, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { MapPanelHeader, MapPanelScrollableArea } from "~/modules/map/components/MapPanel";
import PlannerAreaStatusChip from "~/shared/components/PlannerAreaStatusChip";

import { PlannerAreaSettingsReadOnly } from "./components/PlannerAreaSettingsDisplay";
import { PlannerAreaSettingsForm } from "./components/PlannerAreaSettingsForm";
import PlannerAreaVisitList from "./components/PlannerAreaVisitList";
import { MapEditorPlannerAreaPanelFragment } from "./fragments.generated";
import { useSuspensePlannerAreaQuery } from "./useSuspensePlannerAreaQuery";

export interface MapEditorPlannerAreaPanelContentProps {
    backHref: string;
    mapEditorFeatureId: string;
    readonly: boolean;
    title: string;
}

export function MapEditorPlannerAreaPanelContent({
    backHref,
    mapEditorFeatureId,
    readonly,
    title,
}: MapEditorPlannerAreaPanelContentProps) {
    const { t } = useTranslation("mapEditor");

    const [currentTab, setCurrentTab] = useState("visits");

    const { data } = useSuspensePlannerAreaQuery(mapEditorFeatureId);
    const plannerArea = data.mapEditorFeatureGetById.data as MapEditorPlannerAreaPanelFragment;

    return (
        <>
            <MapPanelHeader>
                <IconButton component={Link} color="inherit" relative="path" to={backHref}>
                    <ArrowBack />
                </IconButton>
                <Typography variant="h6" flex={1}>
                    {title}
                </Typography>
                <PlannerAreaStatusChip plannerAreaStatus={plannerArea.plannerAreaStatus} />
            </MapPanelHeader>
            <MapPanelScrollableArea>
                <Tabs value={currentTab} variant="fullWidth" onChange={(_, newValue) => setCurrentTab(newValue)}>
                    <Tab value="visits" label={t("featureDetailArea.tabVisitList")} />
                    <Tab value="settings" label={t("featureDetailArea.tabSettings")} />
                </Tabs>
                {currentTab === "visits" ? (
                    <PlannerAreaVisitList visits={plannerArea.visits} />
                ) : readonly ? (
                    <PlannerAreaSettingsReadOnly plannerArea={plannerArea} />
                ) : (
                    <PlannerAreaSettingsForm plannerArea={plannerArea} />
                )}
            </MapPanelScrollableArea>
        </>
    );
}
